// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__M0JV5","label":"Category_label__1zjHd","content":"Category_content__jriDT","header":"Category_header__2MWlb","location":"Category_location__3wbKU"};